function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "notepad",
  transform: "translate(0.25 0.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_38",
  "data-name": "Path 38",
  d: "M13.308,1.837H8.959a3.082,3.082,0,0,0-5.638,0H-1.028A2.975,2.975,0,0,0-4,4.809V24.088A2.975,2.975,0,0,0-1.028,27.06H13.308a2.975,2.975,0,0,0,2.972-2.972V4.809a2.975,2.975,0,0,0-2.972-2.972ZM3.81,3.19a.676.676,0,0,0,.661-.531,1.72,1.72,0,0,1,3.338,0,.676.676,0,0,0,.661.531H9.812v.594A1.621,1.621,0,0,1,8.193,5.4H4.088A1.621,1.621,0,0,1,2.469,3.784V3.19Zm11.117,20.9a1.62,1.62,0,0,1-1.619,1.619H-1.028a1.62,1.62,0,0,1-1.619-1.619V4.809A1.621,1.621,0,0,1-1.028,3.19H1.116v.594A2.975,2.975,0,0,0,4.088,6.756H8.193a2.975,2.975,0,0,0,2.972-2.972V3.19h2.144a1.621,1.621,0,0,1,1.619,1.619Zm0,0",
  transform: "translate(4 0)",
  fill: "#023b41",
  stroke: "#023b41",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_39",
  "data-name": "Path 39",
  d: "M108.105,227.634l-4.441,4.336-2.255-2.2a.676.676,0,0,0-.954.959l.009.009,2.728,2.663a.677.677,0,0,0,.945,0l4.914-4.8a.676.676,0,0,0-.945-.968Zm0,0",
  transform: "translate(-94.617 -215.134)",
  fill: "#023b41",
  stroke: "#023b41",
  strokeWidth: 0.5
}));

function SvgNotepad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.78,
    height: 27.56,
    viewBox: "0 0 20.78 27.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.22176eb8.svg";
export { ForwardRef as ReactComponent };